export default __webpack_public_path__ + "static/media/paper.f62e5639.svg";